import { Component, Inject, OnInit } from '@angular/core';

import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Paginacao } from "@app/models/util/paginacao";

import { PosicaoDoCliente } from '@app/models/posicao-do-cliente.model';
import { PosicaoDoClienteService } from '@app/services/posicao-do-cliente.service';
import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-posicao-do-cliente-lista',
  templateUrl: './posicao-do-cliente-lista.component.html'
})
export class PosicaoDoClienteListaComponent implements OnInit {

  lstPosicaoDoCliente: PosicaoDoCliente[];
  paginacao: Paginacao = new Paginacao();
  filtroDescricao: string = "";
  bsModalRef: BsModalRef;

  constructor(
    @Inject(ToastrService) public toastr: ToastrService,
    private posicaoDoClienteService: PosicaoDoClienteService,
    private modalService: BsModalService) { }

  ngOnInit() {
    this.obterTodos(this.filtroDescricao, 1);
  }

  pesquisar() {
    this.obterTodos(this.filtroDescricao, 1);
    this.paginacao.paginaAtual = 1;
  }

  obterTodos(descricao: string, pagina: number) {
    this.posicaoDoClienteService.obterLista(descricao, pagina).toPromise().then(
      data => {
        this.lstPosicaoDoCliente = data.Dados,
          this.paginacao.totalDeItens = data.Total
      }, erro => {
        //this.loading = false;
        this.toastr.warning("Realize a pesquisa novamente.")
      });
  }

  deletar(posicaoDoCliente: PosicaoDoCliente) {
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = "Deseja realmente excluir a posição do cliente: " + posicaoDoCliente.Descricao + "?";
    this.bsModalRef.content.confirmar = () => {
      this.posicaoDoClienteService.deletar(posicaoDoCliente.Id).toPromise().then(
        () => {
          this.obterTodos(this.filtroDescricao, 1);
          this.paginacao.paginaAtual = 1;
        });
    }
  }

  public pageChanged(event: any): void {
    this.obterTodos(this.filtroDescricao, event.page);
  }
}
